import React, { useMemo } from 'react'
import { Tag, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { Modal } from '~/Components/Modal'
import { useAppSelector } from '~/Store'
import { getIsLoadingClaims, getViewClaims } from '~/Store/ApiKey'

interface Props {
  visible: boolean
  onClose: () => void
}

export const ApiKeyClaimsModal = ({ visible, onClose }: Props) => {
  const { t } = useTranslation()
  const viewClaims = useAppSelector(getViewClaims)
  const isLoading = useAppSelector(getIsLoadingClaims)

  // Sắp xếp theo bảng chữ cái (claimType:claimValue) để dễ dò tìm trong danh sách dài.
  const sortedClaims = useMemo(
    () =>
      [...(viewClaims?.claims || [])].sort((a, b) =>
        `${a.claimType}:${a.claimValue}`.localeCompare(
          `${b.claimType}:${b.claimValue}`,
        ),
      ),
    [viewClaims],
  )

  return (
    <Modal
      visible={visible}
      loadingData={isLoading}
      title={t('admin.akViewPermissions')}
      onCancel={onClose}
      footer={null}
    >
      {viewClaims && !viewClaims.hasScopedClaims && viewClaims.claims.length === 0 && (
        <Typography.Paragraph type="secondary">
          {t('admin.akNoRestrictions')}
        </Typography.Paragraph>
      )}
      {sortedClaims.map(claim => (
        <Tag key={claim.productClaimId} style={{ marginBottom: '8px' }}>
          <code>
            {claim.claimType}:{claim.claimValue}
          </code>
        </Tag>
      ))}
    </Modal>
  )
}
